import { Clock, Link as LinkIcon, ListChecks, MessageSquare, Paperclip } from 'lucide-react'
import HorizontalScroller from '../ui/HorizontalScroller'

export default function CardDetailTabs({
    t,
    activeTab,
    onChange,
    totalItems,
    doneItems,
    attachmentsCount,
    dependenciesCount,
    commentsCount,
}) {
    return (
        <HorizontalScroller
            className="compact-scroller"
            viewportClassName="card-detail-tabs"
            scrollStep={200}
            label={t('card.tabs.label')}
        >
            <button
                className={`card-tab ${activeTab === 'checklist' ? 'active' : ''}`}
                onClick={() => onChange('checklist')}
                title={t('card.tabs.checklistTitle')}
            >
                <ListChecks size={14} />
                {t('card.tabs.checklist')} {totalItems > 0 && `(${doneItems}/${totalItems})`}
            </button>
            <button
                className={`card-tab ${activeTab === 'attachments' ? 'active' : ''}`}
                onClick={() => onChange('attachments')}
                title={t('card.tabs.attachmentsTitle')}
            >
                <Paperclip size={14} />
                {t('card.tabs.attachments')} {attachmentsCount > 0 && `(${attachmentsCount})`}
            </button>
            <button
                className={`card-tab ${activeTab === 'dependencies' ? 'active' : ''}`}
                onClick={() => onChange('dependencies')}
                title={t('card.tabs.dependenciesTitle')}
            >
                <LinkIcon size={14} />
                {t('card.tabs.dependencies')} {dependenciesCount > 0 && `(${dependenciesCount})`}
            </button>
            <button
                className={`card-tab ${activeTab === 'comments' ? 'active' : ''}`}
                onClick={() => onChange('comments')}
                title={t('card.tabs.commentsTitle')}
            >
                <MessageSquare size={14} />
                {t('card.tabs.comments')} {commentsCount > 0 && `(${commentsCount})`}
            </button>
            <button
                className={`card-tab ${activeTab === 'history' ? 'active' : ''}`}
                onClick={() => onChange('history')}
                title={t('card.tabs.historyTitle')}
            >
                <Clock size={14} />
                {t('card.tabs.history')}
            </button>
        </HorizontalScroller>
    )
}
